import React, { useEffect, useRef } from 'react';
import { Box } from '@material-ui/core';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsHeatmap from 'highcharts/modules/heatmap';
import { format } from 'date-fns';
import { DIA_SEMANA } from '../utils/variables';
import { useTranslation } from 'react-i18next';

HighchartsHeatmap(Highcharts);

export function HeatMap({
  tipoIndicador,
  dataHeatMap,
  tipoGrafico,
  graphTitle,
  oppositeAxis = false,
  colorIndicador = {},
}) {
  const chartRef = useRef(null);
  const containerRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      if (chartRef.current) {
        chartRef.current.chart.reflow();
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, []);

  return (
    <Box ref={containerRef} style={{ height: '100%', width: '100%' }}>
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={{
          title: {
            text: tipoIndicador[graphTitle],
          },
          chart: {
            type: 'heatmap',
            height: dataHeatMap.height,
          },
          xAxis: {
            categories: dataHeatMap.categorias,
            title: {
              text: t('heatmap.graph.x-axis.hour'),
            },
            opposite: oppositeAxis,
          },
          yAxis: {
            categories: dataHeatMap.fechas,
            title: {
              text:
                tipoGrafico === DIA_SEMANA
                  ? t('heatmap.graph.y-axis.day')
                  : t('heatmap.graph.y-axis.date'),
            },
            labels: {
              formatter: function () {
                if (tipoGrafico === DIA_SEMANA) {
                  return `<b>${t(
                    `response-time-general-day.chart.xAxis.weekdays.${this.value}`
                  )}</b>`;
                }
                return `<b>${this.value}</b><br>
                  <small>${t(
                    `heatmap.graph.dias.semana.${
                      format(new Date(`${this.value} 00:00:00`), 'i') - 1
                    }`
                  )}</small>`;
              },
            },
          },
          colorAxis: { ...tipoIndicador.axisConfig, ...colorIndicador },
          tooltip: {
            enabled: true,
            formatter: function () {
              const xCategory = this.series.xAxis.categories[this.point.x];
              const yCategory = this.series.yAxis.categories[this.point.y];
              const value = this.point.value;
              return (
                `<b>${yCategory}</b><br>` +
                `<b>${
                  value === -1
                    ? t('objective.status.no-monitoring')
                    : `${value} %`
                }</b><br>` +
                `<b>${xCategory}:00 Hrs.</b>`
              );
            },
          },
          series: [
            {
              name: '',
              data: dataHeatMap.dataGrafico,
              dataLabels: {
                enabled: true,
                color: '#000000',
              },
            },
          ],
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                formatter: function () {
                  const value = this.point.value;
                  if (value < 0) return 'S/M';
                  return value;
                },
              },
            },
          },
          credits: {
            enabled: false,
          },
        }}
      />
    </Box>
  );
}
